import t from "react-dom";
import r from "react";
import { boot as n, PoaApp as e } from "@poa/router";
import { boot as o } from "@poa/state";
import { boot as i } from "@poa/i18n";
import { observer as u } from "mobx-react";

function a(r, n) {
  return new Promise(function (e) {
    return t.render(r, n, e);
  });
}

function c() {
  return r.createElement("div", null, "Jambo, jambo! Define your routes in ", "boot({ routes: <here> })", ".");
}

var m = [];

function s(t) {
  m.forEach(t);
}

function h(t) {
  return new Promise(function (u, m) {
    var h;
    if ((h = function (t) {
      var r = {
        react: {
          htmlNode: document.getElementById("root"),
          loadingComponent: null
        },
        router: {
          type: "browser",
          routes: [{
            path: "",
            component: c
          }]
        },
        state: {
          initial: {},
          actions: {}
        },
        env: {}
      };
      return Object.assign({}, r, t);
    }(t)).react.loadingComponent) return a(r.createElement(t.react.loadingComponent, null), h.react.htmlNode).then(function (t) {
      try {
        return f.call(this);
      } catch (t) {
        return m(t);
      }
    }.bind(this), m);

    function f() {
      return i(t.i18n, s).then(function (t) {
        try {
          return o(h, s).then(function (t) {
            try {
              var o;
              return n(h.router, {
                store: (o = t).store,
                actions: o.actions,
                env: o.env
              }, s).then(function (t) {
                try {
                  return a(r.createElement(e, {
                    router: t.router
                  }), h.react.htmlNode).then(function (t) {
                    try {
                      return u();
                    } catch (t) {
                      return m(t);
                    }
                  }.bind(this), m);
                } catch (t) {
                  return m(t);
                }
              }.bind(this), m);
            } catch (t) {
              return m(t);
            }
          }.bind(this), m);
        } catch (t) {
          return m(t);
        }
      }.bind(this), m);
    }

    return f.call(this);
  }.bind(this));
}

function f(t) {
  return function (r) {
    return m.push(r), t && t.namespaces && (r.prototype.tNamespaces = t.namespaces), u(r);
  };
}

export { h as boot, f as Component };